export function sortCountriesAlphabeticallyByLanguage(countries, language) {
    return countries.sort((a, b) => {
        return a.translations[language].common.localeCompare(
            b.translations[language].common
        );
    });
}
